import {
  OpenFeature,
  type FlagEvaluationOptions,
  type PrimitiveValue,
  type EvaluationDetails,
} from '@openfeature/web-sdk';
import { PROVIDER_DOMAIN } from './constants';

export function getFlag<K extends string, V extends PrimitiveValue>(
  key: K,
  defaultFlagValue: V,
  options?: FlagEvaluationOptions,
): EvaluationDetails<V> {
  const client = OpenFeature.getClient(PROVIDER_DOMAIN);

  if (typeof defaultFlagValue === 'boolean') {
    return client.getBooleanDetails(
      key,
      defaultFlagValue,
      options,
    ) as EvaluationDetails<V>;
  }

  if (typeof defaultFlagValue === 'number') {
    return client.getNumberDetails(
      key,
      defaultFlagValue,
      options,
    ) as EvaluationDetails<V>;
  }

  if (typeof defaultFlagValue === 'string') {
    return client.getStringDetails(
      key,
      defaultFlagValue,
      options,
    ) as EvaluationDetails<V>;
  }

  if (typeof defaultFlagValue === 'object') {
    return client.getObjectDetails(
      key,
      defaultFlagValue,
      options,
    ) as EvaluationDetails<V>;
  }

  throw new Error(`Unsupported flag value type: ${typeof defaultFlagValue}`);
}
